// extracted by mini-css-extract-plugin
module.exports = {"header":"Page_header__1CAtR","title":"Page_title__3IJGn","article":"Page_article__2TBHF"};